module.exports = __webpack_public_path__ + "img/auto_journal10s.4ad508e2.jpg";